import { API_URL } from '../../../app-config/constants';
import type { HelpfulAttachment, Visibility } from '../../react/features/Admin/HelpfulResources/types';
import { get, post, put, remove } from '../request';

const ATTACHMENTS = `${API_URL}/helpful-resources/attachments`;

getAllForAdmin.operation = 'READ';
export function getAllForAdmin() {
    return get<HelpfulAttachment[]>(`${ATTACHMENTS}/admin`);
}

getAllForSidebar.operation = 'READ';
export function getAllForSidebar() {
    return get<HelpfulAttachment[]>(`${ATTACHMENTS}/sidebar`);
}

const getterFunctions = ['getAllForAdmin', 'getAllForSidebar'];

type HelpfulAttachmentBaseDto = { id?: string; title: string; visibility: Visibility };
export type HelpfulLinkAttachmentRequest = HelpfulAttachmentBaseDto & { type: 'LINK'; url: string };
export type HelpfulFileAttachmentPayload = {
    fileName: string;
    mediaType: string;
    data: string | null; // null = don't change file on UPDATE
};
export type HelpfulFileAttachmentRequest = HelpfulAttachmentBaseDto &
    HelpfulFileAttachmentPayload & {
        type: 'FILE';
    };
export type HelpfulAttachmentRequest = HelpfulLinkAttachmentRequest | HelpfulFileAttachmentRequest;

createLink.operation = 'CREATE';
createLink.invalidates = getterFunctions;
export function createLink(attachment: HelpfulLinkAttachmentRequest) {
    return post<HelpfulAttachment>(`${ATTACHMENTS}/link`, { postData: attachment });
}

createFile.operation = 'CREATE';
createFile.invalidates = getterFunctions;
export function createFile(attachment: HelpfulFileAttachmentRequest) {
    return post<HelpfulAttachment>(`${ATTACHMENTS}/file`, { postData: attachment });
}

updateLink.operation = 'UPDATE';
export function updateLink(attachment: HelpfulLinkAttachmentRequest) {
    return put<HelpfulAttachment>(`${ATTACHMENTS}/link/${attachment.id}`, { postData: attachment });
}

updateFile.operation = 'UPDATE';
export function updateFile(attachment: HelpfulFileAttachmentRequest) {
    return put<HelpfulAttachment>(`${ATTACHMENTS}/file/${attachment.id}`, { postData: attachment });
}

deleteAttachment.operation = 'DELETE';
export function deleteAttachment(attachmentId: string) {
    return remove(`${ATTACHMENTS}/${attachmentId}`);
}

export function download(attachmentId: string) {
    return get(`${ATTACHMENTS}/${attachmentId}/download`);
}
